/*
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-03 17:53:00
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-02 14:30:06
 * @FilePath: /h5/src/views/Spark/TTSRecorder.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CryptoJS from 'crypto-js';
import { Base64 } from "@/js/base64js";
class Superhuman {
  constructor() {
		this.appId = "557b7e5d";
		this.status = 'init';
        this.text = "";
		this.onSuccess = (jsonData) => {},
		this.onFail = (jsonData) => {}
	}
	// 修改状态
	setStatus(status) {
		this.onWillStatusChange && this.onWillStatusChange(this.status, status)
		this.status = status
	}
	// 连接websocket
	connectWebSocket() {
		this.setStatus('ttsing')
		return getWebsocketUrl().then(url => {
			let ttsWS
			if ('WebSocket' in window) {
				ttsWS = new WebSocket(url)
			} else if ('MozWebSocket' in window) {
				ttsWS = new MozWebSocket(url)
			} else {
				console.log('浏览器不支持WebSocket')
				return
			}
			this.ttsWS = ttsWS
			ttsWS.onopen = e => {
				this.webSocketSend()
			}
			ttsWS.onmessage = e => {
				this.result(e.data)
			}
			ttsWS.onerror = e => {
				this.setStatus('error')
			}
			ttsWS.onclose = e => {
				console.log(e)
			}
		})
	}
	// websocket发送数据
	webSocketSend() {
        const params = {
            "header": {
                "app_id": this.appId,
                "status": 2,
                "request_id": "null",
                "res_id": ""
            },
            "parameter": {
                "oral": {
                    "oral_level":"mid"
                },
                "tts": {
                    "vcn": "x4_lingxiaoxuan_oral",
                    "speed": 50,
                    "volume": 50,
                    "pitch": 50,
                    "bgs": 0,
                    "reg": 0,
                    "rdn": 0,
                    "rhy": 0,
                    "scn": 0,
                    "version": 0,
                    "L5SilLen": 0,
                    "ParagraphSilLen": 0,
                    "audio": {
                        "encoding": "lame",
                        "sample_rate": 16000,
                        "channels": 1,
                        "bit_depth": 16,
                        "frame_size": 0
                    },
                    "pybuf": {
                        "encoding": "utf8",
                        "compress": "raw",
                        "format": "plain"
                    }
                }
            },
            "payload": {
                "text": {
                    "encoding": "utf8",
                    "compress": "raw",
                    "format": "json",
                    "status": 2,
                    "seq": 0,
                    "text": Base64.encode(this.text)
                }
            }
        }
		this.ttsWS.send(JSON.stringify(params))
	}
	start(text,callback,failCallBack) {
        this.text = text;
		this.onSuccess = callback;
		this.onFail = failCallBack;
		this.connectWebSocket();
	}
	close() {
		this.ttsWS.close();
		this.setStatus('init');
	}
	// websocket接收数据的处理
	result(resultData) {
		let jsonData = JSON.parse(resultData)
		// 提问失败
		if (jsonData.header.code !== 0) {
			this.onFail(jsonData);
			return
		}
		this.onSuccess(jsonData);
		if (jsonData.header.code === 0 && jsonData.header.status === 2) {
			this.ttsWS.close()
			this.setStatus('init')
		}
	}
}
function getWebsocketUrl() {
	const httpUrl = new URL("https://cbm01.cn-huabei-1.xf-yun.com/v1/private/medd90fec");
	return new Promise((resolve, reject) => {
		const apiKey = "9e0aa24642a5d8ca15a04b506668cf08";
		const apiSecret = "5ac12ef19702e4f5a9eb1329aa41a193";
		let url = 'wss://' + httpUrl.host + httpUrl.pathname
		let host = location.host
		let date = new Date().toGMTString()
		let algorithm = 'hmac-sha256'
		let headers = 'host date request-line'
		let signatureOrigin = `host: ${host}\ndate: ${date}\nGET ${httpUrl.pathname} HTTP/1.1`
		let signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
		let signature = CryptoJS.enc.Base64.stringify(signatureSha)
		let authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
		let authorization = btoa(authorizationOrigin)
		url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
		resolve(url)
	})
}
export default Superhuman;